'use client';
import { useRef } from 'react';
import { useIsomorphicEffect } from '../useIsomorphicEffect/useIsomorphicEffect.js';

const useLatestRef = (value)=>{
    const ref = useRef(value);
    useIsomorphicEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

export { useLatestRef };
//# sourceMappingURL=useLatestRef.js.map
